// Enums
export enum TransmissionMessageType {
  EMAIL = 'email',
  API_TRIGGER = 'api_trigger',
  INAPP_MESSAGE = 'inapp_message'
}

export enum TransmissionMessagePriority {
  TRANSACTIONAL = 'transactional',
  INITIATIVE = 'initiative'
}

export enum TransmissionMessageStatus {
  PENDING = 'pending',
  QUEUED = 'queued',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

// Payload Types
export interface EmailPayload {
  from: string;
  fromName?: string;
  to: string[];
  cc?: string[];
  bcc?: string[];
  replyTo?: string | string[];
  subject: string;
  body?: string;
  bodyHtml?: string;
  templateType?: string;
  sesConfig?: {
    region?: string;
    configurationSet?: string;
  };
}

export interface ApiTriggerPayload {
  url: string;
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  headers?: Record<string, string>;
  body?: any;
  timeout?: number;
}

export interface InAppMessagePayload {
  url: string;
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  headers?: Record<string, string>;
  body: {
    userId: string;
    message: string;
    type?: string;
    actionUrl?: string;
    [key: string]: any;
  };
  timeout?: number;
}

// Main Model
export interface TransmissionMessage {
  id: string;
  type: TransmissionMessageType;
  priority: TransmissionMessagePriority;
  status: TransmissionMessageStatus;
  scheduledTime?: string | null;
  payload: EmailPayload | ApiTriggerPayload | InAppMessagePayload;
  retryCount: number;
  errorMessage?: string | null;
  transmissionMessageId?: string | null;
  sentAt?: string | null;
  completedAt?: string | null;
  created_on: string;
  last_modified_on: string;
}

// Filter/Query Types
export interface TransmissionMessageFilters {
  page?: number;
  limit?: number;
  type?: TransmissionMessageType;
  priority?: TransmissionMessagePriority;
  status?: TransmissionMessageStatus;
  search?: string;
  startDate?: string;
  endDate?: string;
  retryCount?: number;
  transmissionMessageId?: string;
  sortBy?: 'created_on' | 'scheduledTime' | 'sentAt' | 'completedAt' | 'retryCount';
  sortOrder?: 'asc' | 'desc';
}

// Response Types
export interface TransmissionMessageListResponse {
  items: TransmissionMessage[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
}

